import { render, staticRenderFns } from "./historyPage.vue?vue&type=template&id=63d11ac0&"
import script from "./historyPage.vue?vue&type=script&lang=js&"
export * from "./historyPage.vue?vue&type=script&lang=js&"
import style0 from "./historyPage.vue?vue&type=style&index=0&id=63d11ac0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports